import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import HospitalsSection from './components/HospitalsSection';
import WhyChooseSection from './components/WhyChooseSection';
import RecommendationsSection from './components/RecommendationsSection';
import ContactSection from './components/ContactSection';
import ChatSection from './components/ChatSection';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const isUz = i18n.language === 'uz';
    const title = isUz 
      ? 'MediVoyage - Koreya tibbiy turizmi xizmati'
      : 'MediVoyage - Корейский медицинский туризм';
    const description = isUz
      ? 'Koreyaning eng yaxshi shifoxonalari bilan bog\'lanish. Plastik jarrohlik, ko\'z kasalliklari, stomatologiya, ildiz hujayralari terapiyasi, soch ekish, saratonni davolash va boshqa tibbiy xizmatlar.'
      : 'Связь с лучшими больницами Кореи. Пластическая хирургия, офтальмология, стоматология, терапия стволовыми клетками и другие медицинские услуги.';
    const keywords = isUz
      ? 'koreya tibbiy turizmi, koreyada davolanish, koreya klinikalari, koreyada plastik jarrohlik, tibbiy tarjimon'
      : 'медицинский туризм в Корее, лечение в Корее, корейские клиники, пластическая хирургия в Корее, медицинский переводчик';

    document.title = title;
    
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', description);

    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', keywords);

    // OG tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);
    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', description);
    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', title);
    const twDesc = document.querySelector('meta[name="twitter:description"]');
    if (twDesc) twDesc.setAttribute('content', description);

    // Schema.org JSON-LD
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.medivoyageuz.com';
    
    const schemaWebSite = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      'name': 'MediVoyage',
      'url': siteUrl,
      'description': description,
      'inLanguage': isUz ? 'uz' : 'ru',
      'potentialAction': {
        '@type': 'SearchAction',
        'target': `${siteUrl}/hospitals?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    };

    const schemaMedicalOrg = {
      '@context': 'https://schema.org',
      '@type': 'MedicalOrganization',
      'name': 'MediVoyage',
      'url': siteUrl,
      'description': description,
      'address': {
        '@type': 'PostalAddress',
        'addressCountry': 'KR',
        'addressLocality': 'Seoul',
      },
      'medicalSpecialty': [
        'Plastic Surgery',
        'Ophthalmology',
        'Dentistry',
        'Dermatology',
        'Orthopedics',
        'Stem Cell Therapy',
        'Hair Transplant',
        'Oncology',
      ],
    };

    let scriptWebSite = document.getElementById('schema-website');
    if (!scriptWebSite) {
      scriptWebSite = document.createElement('script');
      scriptWebSite.id = 'schema-website';
      scriptWebSite.type = 'application/ld+json';
      document.head.appendChild(scriptWebSite);
    }
    scriptWebSite.textContent = JSON.stringify(schemaWebSite);

    let scriptMedicalOrg = document.getElementById('schema-medical-org');
    if (!scriptMedicalOrg) {
      scriptMedicalOrg = document.createElement('script');
      scriptMedicalOrg.id = 'schema-medical-org';
      scriptMedicalOrg.type = 'application/ld+json';
      document.head.appendChild(scriptMedicalOrg);
    }
    scriptMedicalOrg.textContent = JSON.stringify(schemaMedicalOrg);

    // Canonical URL
    let linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.rel = 'canonical';
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.href = siteUrl;

    return () => {
      scriptWebSite?.remove();
      scriptMedicalOrg?.remove();
    };
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <HospitalsSection />
      <WhyChooseSection />
      <RecommendationsSection />
      <ContactSection />
      <ChatSection />
      <Footer />
    </div>
  );
}
